import { render, staticRenderFns } from "./CategoryAndBrandUpdaterView.vue?vue&type=template&id=4238455b&scoped=true&"
import script from "./CategoryAndBrandUpdaterView.vue?vue&type=script&lang=js&"
export * from "./CategoryAndBrandUpdaterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238455b",
  null
  
)

export default component.exports